import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionItemProps, accordionItemStyles, accordionPanelStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-accordion-item',
  template: `
    <div [ngClass]="accordionItemStyles" #ElementRef>
      <button
        (click)="toggleOpen()"
        [disabled]="isDisabled"
        [attr.aria-expanded]="!!isOpen"
        [id]="'accordion-button-' + id"
        [attr.aria-controls]="'accordion-panel-' + id"
      >
        <span>{{ title }}</span>
        <kite-icon
          size="md"
          name="chevron-down"
          [css]="{
            svg: {
              transition: 'transform 0.2s ease-in-out',
              transform: isOpen || (selected !== undefined && selected === id) ? 'rotate(-180deg)' : 'rotate(0)'
            }
          }"
        ></kite-icon>
      </button>
      <div
        [ngClass]="accordionPanelStyles"
        [id]="'accordion-panel-' + id"
        [attr.aria-labelledby]="'accordion-button-' + id"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class AccordionItemComponent {
  /**
   * Título del item
   */
  @Input() title: AccordionItemProps['title'];

  /**
   * Estado deshabilitado del item
   */
  @Input() isDisabled: AccordionItemProps['isDisabled'];

  /**
   * id que identifica el número de item
   */
  @Input() id: AccordionItemProps['id'];

  /**
   * boolean que determina si se pueden abrir varios items a la vez
   */
  @Input() allowMultiple: AccordionItemProps['allowMultiple'];

  /**
   * id del item seleccionado
   */
  @Input() selected: AccordionItemProps['selected'];

  /**
   * Css del componente
   */
  @Input() css: AccordionItemProps['css'];

  isOpen = false;
  @Output()
  onClick = new EventEmitter();

  public get accordionItemStyles(): string[] {
    return [accordionItemStyles({ css: this.css }).className];
  }

  public get accordionPanelStyles(): string[] {
    return [
      accordionPanelStyles({ isOpen: (this.selected !== undefined && this.selected === this.id) || !!this.isOpen })
        .className,
    ];
  }

  toggleOpen() {
    if (!this.allowMultiple) {
      if (this.selected === this.id) {
        this.onClick.emit(-1);
      } else {
        this.onClick.emit(this.id);
      }
    } else {
      this.isOpen = !this.isOpen;
    }
  }
}
